var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHamburgerMenuClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 720 720",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#14144B;stroke-width:0px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M620.01,548.11c19.86,19.86,19.86,52.05,0,71.89-19.84,19.86-52.04,19.86-71.89,0l-188.11-188.11-188.11,188.11c-19.86,19.86-52.05,19.86-71.89,0-19.86-19.84-19.86-52.04,0-71.89l188.11-188.11L99.99,171.89c-19.86-19.86-19.86-52.05,0-71.89,19.84-19.86,52.04-19.86,71.89,0l188.11,188.11,188.11-188.11c19.86-19.86,52.05-19.86,71.89,0,19.86,19.84,19.86,52.04,0,71.89l-188.11,188.11,188.11,188.11Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburgerMenuClose);
export default __webpack_public_path__ + "static/media/hamburger-menu-close.7c9e1318e73daa55014b383f31a6a967.svg";
export { ForwardRef as ReactComponent };